/* USER BIRTH CHART LIST */
export const GET_USER_BIRTH_CHART_LIST = "GET_USER_BIRTH_CHART_LIST"
export const GET_USER_BIRTH_CHART_LIST_SUCCESS = "GET_USER_BIRTH_CHART_LIST_SUCCESS"
export const GET_USER_BIRTH_CHART_LIST_FAIL = "GET_USER_BIRTH_CHART_LIST_FAIL"
export const GET_BIRTH_CHART_REPORT = "GET_BIRTH_CHART_REPORT"